// extracted by mini-css-extract-plugin
export var subscribe = "Subscribe-module--subscribe--4cac7";
export var subtitle = "Subscribe-module--subtitle--3ba55";
export var title = "Subscribe-module--title--aeb5b";
export var titleWithPromo = "Subscribe-module--titleWithPromo--52949";